import React from "react";
import { useNavigate } from "react-router-dom";
import NewsList from "./NewsList";

export default function ClickableNewsList(props) {
  const navigate = useNavigate();
  const handleItemClick = (id, item) => {
    const type = item?.source_detail?.source_type?.toLowerCase();

    if (["site", "blog"].includes(type)) {
      navigate(`/news/web/${id}`);
    } else if (["radio", "tv"].includes(type)) {
      navigate(`/news/audiovisual/${id}`);
    } else if (type === "impresso") {
      navigate(`/news/impresso/${id}`);
    } else {
      navigate(`/news/${id}`);
    }
  };

  return <NewsList {...props} onItemClick={handleItemClick} />;
}
